import React from "react";
import {
    Box,
    FormField,
    Modal,
    Icon,
    Popover,
    SpaceBetween
} from "@amzn/awsui-components-react/polaris";
import {
    FremontButton,
    FremontTextarea
} from "utils/CommonComponents";

/**
 * This is the modal that pops up to enter the reason data request (for rejection or span decom)
 * and then submit the request.  The modal is hidden
 * by default while the "visible" prop is false. When the add rejection button is clicked, the state of
 * "isAddRejectionClicked" is flipped through the handleRejectionModalClick method which sets the visible prop to true
 * and renders the modal. Hitting "Confirm" calls the method to submit the request.
 */
const OrderReasonNoteModal = props => (
    <Modal
        visible={props.isAddReasonClicked}
        header={props.reasonHeader}
        size="large"
        onDismiss={props.handleCloseReasonModal}
        footer={
            <Box variant="span" float="right">
                <Box padding={{ left: "s" }}>
                    <SpaceBetween
                        direction="horizontal"
                        size="m"
                    >
                        <Box margin={{ top: "xxs" }}>
                            <Popover
                                dismissButton
                                position="top"
                                size="small"
                                triggerType="custom"
                                content={
                                    <Box>{props.popoverMessage}</Box>
                                }
                            >
                                <Icon
                                    name="status-warning"
                                    variant="subtle"
                                />
                            </Popover>
                        </Box>
                        <FremontButton
                            id="submitAddReasonButton"
                            loading={props.isAddReasonInProgress}
                            variant="primary"
                            onClick={props.handleAddReasonSubmit}
                            disabled={!props.reasonBody}
                        >
                            {props.isAddReasonInProgress ? "Submitting..." : "Submit"}
                        </FremontButton>
                    </SpaceBetween>
                </Box>
            </Box>
        }
    >
        <FormField
            label={props.reasonLabel}
            errorText={props.errorText}
        >
            <FremontTextarea
                id="notes"
                disabled={props.isAddReasonInProgress}
                value={props.reasonBody}
                onInput={props.handleReasonInputChange}
            />
        </FormField>
    </Modal>
);

export default OrderReasonNoteModal;